import { isDesktop } from 'react-device-detect';
import WinHighlightController from '../../controllers/WinHighlightController';
import MainGridController from '../../controllers/grid/MainGridController';
import { COMPONENTS } from '../../lib/constants';
import { WinHighlightViewGrid } from './WinHightlightViewGrid';
let scale = isDesktop ? 1 : 2;
export const WinHighlight = {
	name: COMPONENTS.WIN_HIGHLIGHT,
	child: true,
	zIndex: 2,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: WinHighlightController,
			name: 'WinHighlightController',
			config: {
				item: 'win_highlight',
				win: 0,
				holder: 'win_highlight_holder'
			}
		},
		{
			Controller: MainGridController,
			name: 'WinHighlightViewGrid',
			config: WinHighlightViewGrid
		}
	],
	components: [
		{
			name: 'win_highlight_holder_up',
			type: 'Sprite',
			components: [
				{
					name: 'win_highlight_holder',
					type: 'Sprite',
					position: {
						x: 300,
						y: 270
					},
					components: [
						{
							name: 'win_highlight',
							type: 'SimpleButton',
							components: [
								{
									name: 'win_counter',
									type: 'Text',
									text: 'WIN_HIGHLIGHT_COUNTER'
									// position: { x: -100, y: 130 },
								},

								{
									name: 'wing_left',
									type: 'Sprite',
									img: 'wing_left',
									position: { x: -330, y: -40 },
									scale: { x: scale, y: scale }
								},
								{
									name: 'wing_right',
									type: 'Sprite',
									img: 'wing_right',
									position: { x: 350, y: -40 },
									scale: { x: scale, y: scale }
								},
								{
									name: 'core',
									type: 'Sprite',
									img: 'core',
									position: { x: 0, y: 0 },
									scale: { x: scale, y: scale },
									anchor: {
										x: 0.5,
										y: 0.5
									}
								}
							]
						}
					]
				}
			]
		}
	]
};
